import { Provider } from '@angular/core';
import { BrowserUtilsService } from '@cargos/sprintpay-services';
import { CustomerService } from 'src/app/services';
import { SecureMessagingService } from 'src/app/services/secure-messaging/secure-messaging.service';
import { SprintpayButtonService } from 'src/app/services/sprintpay-button/sprintpay-button.service';

export const openerServicesProviders: Provider[] = [
    {
        provide: SecureMessagingService,
        useFactory: (browserUtilsService: BrowserUtilsService): SecureMessagingService | null =>
            browserUtilsService?.hasOpener() ? new SecureMessagingService() : null,
        deps: [BrowserUtilsService],
    },
    {
        provide: SprintpayButtonService,
        useFactory: (
            customerService: CustomerService,
            browserUtilsService: BrowserUtilsService,
            secureMessagingService: SecureMessagingService
        ): SprintpayButtonService | null => {
            return browserUtilsService?.hasOpener()
                ? new SprintpayButtonService(customerService, browserUtilsService, secureMessagingService)
                : null;
        },
        deps: [CustomerService, BrowserUtilsService, SecureMessagingService],
    },
];
